import { Component, OnInit, Input } from '@angular/core';
import { ProductListComponent } from '../../product/product-list/product-list.component';
import { CategoryService } from '@app/services/Category/category.service';
import { LoaderService } from '@app/services/loader/loader.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-categories-list',
  templateUrl: './categories-list.component.html',
  styleUrls: ['./categories-list.component.scss']
})
export class CategoriesListComponent implements OnInit {
  categories: any;
  sellProductInfoId: any;
  userInfoId: any;

  @Input() productList!: ProductListComponent;

  constructor(private categoryService: CategoryService,
    private route: ActivatedRoute,  
    private loader:LoaderService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.sellProductInfoId = params['id'];
      this.userInfoId = params['uid'];
      //if(this.userInfoId && this.sellProductInfoId){
        this.getCategoryList();
      //}
    });
    //this.getCategoryList();
    // this.selectedCategory = 0;
  }

  getCategoryList() {
    this.loader.show();
    this.categoryService.getAll().subscribe({
      next: (data) => {
        this.categories = data;
      }
    });
  }
  
  // Set name for SEO URL 
  getHyphenatedString(limitedTitle :any) {
    let hyphenatedString = limitedTitle
      .replaceAll(" ", "-")
      .toLowerCase();
    return hyphenatedString;
  }
}
